import { FireLogger } from '@fire/logger';
import { AppConfig } from '../config/app.config';


export const fireLogger = new FireLogger({
  moduleName: AppConfig.pascalCaseName,
  level: FireLogger.Levels.Trace,
});


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/utils/fire-logger.ts